import { render, staticRenderFns } from "./sposter.vue?vue&type=template&id=6293d66a&scoped=true"
import script from "./sposter.vue?vue&type=script&lang=js"
export * from "./sposter.vue?vue&type=script&lang=js"
import style0 from "./sposter.vue?vue&type=style&index=0&id=6293d66a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6293d66a",
  null
  
)

export default component.exports